import { atom } from 'jotai'

import type { LoginMethod } from '@/lib/analytics'
import store from '@/lib/configs/store-config'

export interface AuthAnalyticsEvent {
  method: LoginMethod
  userId: string
  kind: 'login' | 'signup'
}

/**
 * One-shot, non-persisted signal written only at real login/signup success
 * points. Session restore never writes it, which is what separates a fresh
 * `Log in` from a page reload that merely re-hydrates the auth cookie.
 * AnalyticsSync consumes (reads + clears) it exactly once.
 */
export const authAnalyticsEventAtom = atom<AuthAnalyticsEvent | null>(null)

export function emitAuthAnalytics(event: AuthAnalyticsEvent): void {
  store.set(authAnalyticsEventAtom, event)
}
